import React from 'react'
import { Text, Box, Stack, Flex  } from '@chakra-ui/react'
import { useMediaQuery } from 'react-responsive'

interface ITitleResumeProps {
  titulo: string
}

// Titulo Subscription Resume
const Title = ({ titulo }: ITitleResumeProps) => {
  const isMobile = useMediaQuery({ query: '(max-width: 480px)' })

  return (
  <Stack  data-testid='titles' margin='auto'  gap={['8px','16px']} textAlign={'center'} alignItems={'center'} maxW={['331px', '600px']}>
    {!isMobile &&
    <Flex flex={1} flexDir='column'>
      <Text data-testid='title' textAlign='center' textStyle='h3Bold' size='lg' line-height='2xl' color='secondary.900' >¡Último paso!</Text>      
      <Text data-testid='title-subtitle' textAlign='center' textStyle='h4Bold' size='2xm' line-height='xl' color='secondary.900'  as='span'>Confirmá la suscripción a Interbanking</Text>
    </Flex>
    }
    {isMobile &&
      <Text data-testid='title-mobile' textAlign='center' textStyle='h5Bold' color='secondary.900' >¡Último paso! Confirmá la suscripción a Interbanking</Text>
    }
    <Box maxW={['302px', '532px']}  mt={['0', '16px']} textAlign={'center'}>
      <Text data-testid='title-caption'  textAlign='center' textStyle={'bodySm'} size={'4xs'} line-height={'xs'}  color='secondary.900' >{titulo}</Text>
    </Box>
  </Stack>
)}

export default Title